import { Select } from "antd";
import { FC } from "react";

const SelectApiField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="yassocial" >یاس سوشیال</Select.Option>
      <Select.Option key="followerma" >فالور ما</Select.Option>
    </Select>
  )
}

export default SelectApiField
